export const handleDownload = (url, filename) => {
  return new Promise(async (resolve) => {
    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Download failed with status ${response.status}`);
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = filename || "";
      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);

      window.URL.revokeObjectURL(downloadUrl);

      resolve(false); // success
    } catch (err) {
      resolve(true); // failed
    }
  });
};

export const downloadDirectFile = (url, filename) => {
  return new Promise((resolve) => {
    try {
      const link = document.createElement("a");

      link.href = url;
      link.download = filename || "download";
      link.target = "_blank";

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);

      resolve(false);
    } catch (err) {
      resolve(true);
    }
  });
};
